$(document).on('ready', () => {
  if (!$('.section-technology-accordion').length) {
    return;
  }

  $('.section-technology-accordion-tab-title').on('click', function (e) {
    e.preventDefault();

    var $parent = $(this).parent(),
      $answer = $(this).next(),
      open = !$parent.hasClass('closed');

    $('.section-technology-accordion-faq-list').not($answer).slideUp();
    $('.section-technology-accordion-tab').not($parent).addClass('closed').removeClass('active');

    if (!open) {
      $('.section-technology-accordion-tab').not($parent).fadeOut(100, () => {
        $parent.addClass('active').removeClass('closed');
        $answer.slideDown();
      });
    } else {
      $('.section-technology-accordion-tab').not($parent).fadeIn(100, () => {
        $parent.addClass('closed').removeClass('active');
        $answer.slideUp();
      });
    }
  });

  $('.section-technology-accordion .section-technology-accordion-faq-question').on('click', function (e) {
    e.preventDefault();

    var $parent = $(this).parent(),
      $answer = $(this).next(),
      open = !$parent.hasClass('closed');

    $('.section-technology-accordion-faq-answer').not($answer).slideUp();
    $('.section-technology-accordion-faq-item').not($parent).addClass('closed');

    if (!open) {
      $parent.removeClass('closed');
      $answer.slideDown();
    } else {
      $parent.addClass('closed');
      $answer.slideUp();
    }
  });

  $('.section-technology-accordion-tab-title').on('mouseenter', function () {
    var parent_block = $(this).closest('.section-technology-accordion'),
      item_index = parent_block.find('.section-technology-accordion-tab-title').index(this);

    $(this).closest('.section-technology-accordion-tab').addClass('hovered');

    parent_block.find('.section-technology-accordion-tab').removeClass('hovered');
    parent_block.find('.section-technology-accordion-tab:nth-child(' + (item_index + 1) + ')').addClass('hovered');

    parent_block.find('.section-technology-accordion-image').removeClass('section-technology-accordion-image-active');
    parent_block.find('.section-technology-accordion-image:nth-child(' + (item_index + 1) + ')').addClass('section-technology-accordion-image-active');
  });
  
  $('.section-technology-accordion-tab-title').on('mouseleave', function () {
    //var parent_block = $(this).closest('.section-technology-accordion');

    $(this).closest('.section-technology-accordion-tab').removeClass('hovered');
    //parent_block.find('.section-technology-accordion-tab').removeClass('hovered');
  });
});



// WEBPACK FOOTER //
// ./scripts/blocks/technology-new-accordion.js